import React from 'react'
import {Card, Typography, Space} from 'antd'
import {Helmet} from 'react-helmet'

const {Title, Text, Link} = Typography

const ContactsPage: React.FC = () => {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            background: 'var(--color-bg-hover)',
            padding: 16
        }}>
            <Helmet title='Контакты'/>
            <Card style={{maxWidth: 500, width: '100%', borderRadius: 12, boxShadow: '0 4px 12px rgba(0,0,0,0.1)'}}>
                <Title level={3} style={{textAlign: 'center', marginBottom: 24}}>
                    Контакты
                </Title>
                <Space direction="vertical" size="large" style={{width: '100%'}}>
                    <Text>
                        Если у вас возникли вопросы, проблемы со входом или предложения — напишите нам в любой из групп:
                    </Text>
                    <Card size="small">
                        <Space direction="vertical">
                            <Text strong>Telegram</Text>
                            <Link href="https://t.me/geekenglishru" target="_blank">
                                t.me/geekenglishru
                            </Link>
                        </Space>
                    </Card>
                    <Card size="small">
                        <Space direction="vertical">
                            <Text strong>ВКонтакте</Text>
                            <Link href="https://vk.ru/voxlingua" target="_blank">
                                vk.ru/voxlingua
                            </Link>
                        </Space>
                    </Card>
                </Space>
            </Card>
        </div>
    )
}

export default ContactsPage
